export interface ComercialCalculadoraParameter {
  id: string
  key: string
  value: string
  description?: string | null
  created_at: string
  updated_at: string
}

export const CALCULADORA_PARAM_KEYS = {
  NR1_VALOR_INDIVIDUAL: 'nr1_valor_individual',
  NR1_COMISSAO_PERCENTUAL_MAXIMO: 'nr1_comissao_percentual_maximo',
} as const

export type CalculadoraParametrosConfig = {
  nr1ValorIndividual: number
  comissaoPercentualMaximo: number
}
